// src/api/api.js
import axios from "axios";
import { ElMessage } from "element-plus";

// 创建 axios 实例
const api = axios.create({
//   baseURL: "http://localhost:8081/manage/api",
    baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000, // 请求超时时间
});

/**
 * 封装 GET 请求
 * @param {string} url 接口地址
 * @param {object} params 查询参数
 * @returns {Promise}
 */
export const getApi = (url, params) => {
  return api.get(url, { params });
};

// 请求拦截器：统一添加 token 和其他请求头
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["X-Token"] = token;
      //   config.headers['Cookie'] = `Admin-Token=${token}; sidebarStatus=0`;
    }
    config.headers["Accept"] = "application/json, text/plain, */*";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器：统一处理错误
api.interceptors.response.use(
  (response) => {
    if (response.data.code === 20000) {
      return response.data;
    } else {
      return Promise.reject(new Error(response.data.message || "请求失败"));
    }
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // token 失效，跳转到登录页面
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// 产品相关的 API
export const getAllProducts = () => {
  return api.get("/product/getAll");
};

export const getProductAllPropertiesById = (productId) => {
  return getApi("/product/getAllPropertyById", { productId: productId });
};

export const addProduct = (data) => {
  return api.post("/product/add", data);
};

export const editProduct = (data) => {
  return api.post("/product/editProperty", data);
};

export const onIndex = (data) => {
  return api.post("/product/onIndex", data);
};

export const offIndex = (data) => {
  return api.post("/product/offIndex", data);
};

export const changeProductSort = (data) => {
  return api.post("/product/allSort", data);
};

export const deleteProduct = (productId) => {
  return api.post(`/product/delete/${productId}`);
};

export const getQiniuToken = () => {
  return api.get("/qiniu/upload-token"); // 替换为你的实际后端接口
};

export const getNavPicName = () => {
  return getApi("/nav/getAllPath", {});
};

export const getIndexProductPicName = () => {
  return getApi("/nav/getProductAllPath", {});
};

export const addNavPic = (data) => {
  return api.post("/nav/add", data);
};

export const addNavProductPic = (data) => {
  return api.post("/nav/addProductImg", data);
};

export const getAboutus = () => {
  return getApi("/aboutus/all", {});
};

export const updateAboutUs = (data) => {
  return api.post("/aboutus/add", data);
};

export const getEnvironment = () => {
  return getApi("/environment/all", {});
};

export const updateEnvironment = (data) => {
  return api.post("/environment/add", data);
};

export const getQuality = () => {
  return getApi("/quality/all", {});
};

export const updateQuality = (data) => {
  return api.post("/quality/add", data);
};

export const getJoinus = () => {
  return getApi("/joinus/all", {});
};

export const updateJoinus = (data) => {
  return api.post("/joinus/add", data);
};

export const getAftersale = () => {
  return getApi("/aftersale/all", {});
};

export const updateAftersale = (data) => {
  return api.post("/aftersale/add", data);
};

export const getContact = () => {
    return getApi("/contact/all", {});
  };
  
  export const updateContact = (data) => {
    return api.post("/contact/add", data);
  };

export default api;
